import axios from "./axios";

const API_URL = axios.defaults.baseURL;
const BASE_URL = "/event/";
const CATEGORY_URL = "/category";


export const getCategoryEntity = (eventID, categoryType) => {
    return axios.get(
        `${API_URL}${BASE_URL}${eventID}${CATEGORY_URL}?category_type=${categoryType}`
    );
};


export const addCategoryEntity = (eventID, payload) => {
    return axios.post(
        `${API_URL}${BASE_URL}${eventID}${CATEGORY_URL}`,
        payload
    );
};

export const editCategoryEntity = (eventID, categoryID, payload) => {
    return axios.put(
        `${API_URL}${BASE_URL}${eventID}${CATEGORY_URL}/${categoryID}`,
        payload
    );
};


export const deleteCategoryEntity = (eventID, categoryID, params = {}) => {
    return axios.delete(
        `${API_URL}${BASE_URL}${eventID}${CATEGORY_URL}/${categoryID}`,
        { params }
    );
};


export const reorderCategoryEntity = (eventID, payload) => {
    return axios.put(
        `${API_URL}${BASE_URL}${eventID}${CATEGORY_URL}/reorder`,
        payload
    );
};
